import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

export const noticeAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["noticeVo"],
  reducerPath: "noticeAPI",
  endpoints: (builder) => ({
    getS3Url: builder.mutation({
      query: ({ data }) => ({
        url: `common/s3-upload-url/attachment`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    addNotice: builder.mutation({
      query: (data) => ({
        url: `notice`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    modifyNotice: builder.mutation({
      query: ({ notice_idx, data }) => ({
        url: `notice/${notice_idx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // ========================= notice 목록 =========================
    noticeList: builder.query({
      query: (search) => ({
        url: `/notice/search`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: search,
      }),
    }),
    // ========================= notice 목록(고정) =========================
    noticePinList: builder.query({
      query: () => ({
        url: `/notice/important-notice`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    getGroupStore: builder.query({
      query: ({ groupId, queryString }) => ({
        url: `/users/group/${groupId}/store`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: queryString,
      }),
      transformResponse: (response: any) => response.data,
    }),
    getNotice: builder.mutation({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getImportantNoticeCount: builder.query({
      query: () => ({
        url: "notice/important-notice-count",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    deleteNotice: builder.mutation({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => {
        console.log(1);
        response.data;
      },
    }),
    getNoticeDetail: builder.query({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    changeStores: builder.mutation({
      query: ({ noticeIdx, data }) => ({
        url: `notice/${noticeIdx}/store`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    getFulfillData: builder.mutation({
      query: (fullfillIdx) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    fulfillRegister: builder.mutation({
      query: ({ fullfillIdx, data }) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    fulfillModify: builder.mutation({
      query: ({ fullfillIdx, data }) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    deleteComment: builder.mutation({
      query: (comment_idx) => ({
        url: `common/comment/${comment_idx}`,
        method: "DELETE",
      }),
      transformResponse: (response: any) => response,
    }),
    getCurrentFulfill: builder.query({
      query: (noticeIdx) => ({
        url: `/notice/${noticeIdx}/board`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    getFulfilExcel: builder.mutation({
      query: (fullfillIdx) => ({
        url: `notice/${fullfillIdx}/fulfilment`,
        method: "GET",
        responseHandler: async (response) => {
          // content-disposition 헤더에서 파일명 추출
          const contentDisposition = await response.headers.get("content-disposition");
          let filename = "download.xlsx"; // 기본 파일명 (추출 실패 시 사용)

          if (contentDisposition) {
            const match = contentDisposition.match(/filename="(.+)"/);
            if (match && match[1]) {
              filename = decodeURIComponent(match[1]); // 파일명 디코딩
            }
          }

          // Blob URL 생성
          const blob = await response.blob();
          const blobUrl = window.URL.createObjectURL(blob);

          // 링크 요소 생성 및 클릭으로 다운로드 시작
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = filename;
          document.body.appendChild(link);
          link.click();

          // 정리
          document.body.removeChild(link);
          window.URL.revokeObjectURL(blobUrl);
        },
        headers: {
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useGetS3UrlMutation,
  useAddNoticeMutation,
  useGetGroupStoreQuery,
  useGetNoticeMutation,
  useModifyNoticeMutation,
  useChangeStoresMutation,
  useNoticeListQuery,
  useNoticePinListQuery,
  useGetNoticeDetailQuery,
  useDeleteNoticeMutation,
  useFulfillRegisterMutation,
  useGetFulfillDataMutation,
  useFulfillModifyMutation,
  useGetCurrentFulfillQuery,
  useGetImportantNoticeCountQuery,
  useGetFulfilExcelMutation,
  useDeleteCommentMutation,
} = noticeAPI;
